import React, { useState } from 'react'
import { Download, ZoomIn, ZoomOut, RotateCw } from 'lucide-react'
import { ShadcnDialog as Dialog, DialogContent, ShadcnButton } from '../ui'

interface DocumentViewerProps {
 url: string
 name: string
 isOpen: boolean
 onClose: () => void
}

export const DocumentViewer: React.FC<DocumentViewerProps> = ({
 url,
 name,
 isOpen,
 onClose,
}) => {
 const [zoom, setZoom] = useState(100)
 const [rotation, setRotation] = useState(0)

 const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(url)
 const isPdf = /\.pdf$/i.test(url)

 const handleDownload = () => {
 const a = document.createElement('a')
 a.href = url
 a.download = name
 a.target = '_blank'
 a.click()
 }

 const handleZoomIn = () => {
 setZoom((prev) => Math.min(prev + 25, 200))
 }

 const handleZoomOut = () => {
 setZoom((prev) => Math.max(prev - 25, 50))
 }

 const handleRotate = () => {
 setRotation((prev) => (prev + 90) % 360)
 }

 const resetView = () => {
 setZoom(100)
 setRotation(0)
 }

 return (
 <Dialog
 open={isOpen}
 onOpenChange={(open) => {
 if (!open) {
 onClose()
 }
 }}
 >
 <DialogContent className="w-[70vw] max-w-[70vw] h-[70vh] p-0">
 <div className="flex flex-col h-full">
 <div className="flex items-center justify-between p-4 border-b">
 <div className="flex-1 min-w-0 mr-4">
 <h3 className="text-lg font-semibold truncate">{name}</h3>
 <p className="text-xs text-muted-foreground mt-1">
 Clique fora do popup, pressione ESC ou use o X para fechar.
 </p>
 </div>
 <div className="flex items-center gap-2">
 {isImage && (
 <>
 <ShadcnButton
 type="button"
 variant="outline"
 size="sm"
 onClick={handleZoomOut}
 disabled={zoom <= 50}
 >
 <ZoomOut className="h-4 w-4" />
 </ShadcnButton>
 <span className="text-sm text-muted-foreground min-w-[60px] text-center">
 {zoom}%
 </span>
 <ShadcnButton
 type="button"
 variant="outline"
 size="sm"
 onClick={handleZoomIn}
 disabled={zoom >= 200}
 >
 <ZoomIn className="h-4 w-4" />
 </ShadcnButton>
 <ShadcnButton
 type="button"
 variant="outline"
 size="sm"
 onClick={handleRotate}
 >
 <RotateCw className="h-4 w-4" />
 </ShadcnButton>
 <ShadcnButton
 type="button"
 variant="outline"
 size="sm"
 onClick={resetView}
 >
 Reset
 </ShadcnButton>
 </>
 )}
 <ShadcnButton
 type="button"
 variant="outline"
 size="sm"
 onClick={handleDownload}
 >
 <Download className="h-4 w-4 mr-2" />
 Baixar
 </ShadcnButton>
 </div>
 </div>

 <div className="flex-1 overflow-auto bg-surface p-4">
 {isImage ? (
 <div className="flex items-center justify-center h-full">
 <img
 src={url}
 alt={name}
 style={{
 transform: `rotate(${rotation}deg) scale(${zoom / 100})`,
 maxWidth: '100%',
 maxHeight: '100%',
 objectFit: 'contain',
 }}
 className="transition-transform duration-200"
 />
 </div>
 ) : isPdf ? (
 <iframe
 src={url}
 className="w-full h-full border-0"
 title={name}
 />
 ) : (
 <div className="flex items-center justify-center h-full">
 <div className="text-center">
 <p className="text-muted-foreground mb-4">
 Visualização não disponível para este tipo de arquivo
 </p>
 <ShadcnButton
 type="button"
 variant="outline"
 onClick={handleDownload}
 >
 <Download className="h-4 w-4 mr-2" />
 Baixar Arquivo
 </ShadcnButton>
 </div>
 </div>
 )}
 </div>
 </div>
 </DialogContent>
 </Dialog>
 )
}

